(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[34],{

/***/ 6562:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/member-enrollment/welcome",
      function () {
        return __webpack_require__(8113);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_2__);



var ref = next_config__WEBPACK_IMPORTED_MODULE_2___default()(), CZEN_GENERAL = ref.publicRuntimeConfig.CZEN_GENERAL;
var CareLogo = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 100 40",
        height: 40,
        width: 100,
        "data-testid": "careAltLogo",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("image", {
            width: 100,
            height: 40,
            href: "".concat(CZEN_GENERAL, "/s/d/ttp/cfb-logo-mfe.svg")
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CareLogo);


/***/ }),

/***/ 9051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export policyClickData */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7645);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9561);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1749);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2660);






// Constants
var ref = next_config__WEBPACK_IMPORTED_MODULE_2___default()(), CZEN_GENERAL = ref.publicRuntimeConfig.CZEN_GENERAL;
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(theme) {
    return {
        textContainer: {
            marginTop: theme.spacing(2)
        }
    };
});
var TERMS_OF_USE = _constants__WEBPACK_IMPORTED_MODULE_3__/* .TEXTS.STATIC.TERMS_OF_USE */ .oS.STATIC.TERMS_OF_USE;
/* eslint-disable camelcase */ var policyClickData = {
    terms: {
        name: _constants__WEBPACK_IMPORTED_MODULE_3__/* .EventNames.TERMS_OF_USE_CLICKED */ .Vy.TERMS_OF_USE_CLICKED,
        link_text: "Terms of Use"
    },
    privacy: {
        name: _constants__WEBPACK_IMPORTED_MODULE_3__/* .EventNames.PRIVACY_POLICY_CLICKED */ .Vy.PRIVACY_POLICY_CLICKED,
        link_text: "Privacy Policy"
    }
};
var TermsOfUse = function(param) {
    var amplitudeLogger = param.amplitudeLogger, buttonCaption = param.buttonCaption, _abbreviated = param.abbreviated, abbreviated = _abbreviated === void 0 ? false : _abbreviated, _flat = param.flat, flat = _flat === void 0 ? false : _flat;
    var handlePolicyEvent = function(key) {
        return function() {
            return amplitudeLogger(policyClickData[key]);
        };
    };
    var classes = useStyles();
    var abbreviatedTOU = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: flat ? "" : classes.textContainer,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            careVariant: "body3",
            color: "textSecondary",
            children: [
                "By choosing ",
                buttonCaption,
                " you agree to our\xa0",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    id: "terms-of-use-link",
                    inline: true,
                    onClick: handlePolicyEvent("terms"),
                    href: "".concat(CZEN_GENERAL, "/enterprise/terms.do"),
                    target: "_blank",
                    careVariant: "link3",
                    rel: "noreferrer",
                    children: policyClickData.terms.link_text
                }),
                " and ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    id: "privacy-policy-link",
                    inline: true,
                    onClick: handlePolicyEvent("privacy"),
                    href: "".concat(CZEN_GENERAL, "/privacy-policy-popup-p1031.html"),
                    careVariant: "link3",
                    target: "_blank",
                    rel: "noreferrer",
                    children: policyClickData.privacy.link_text
                }),
                "."
            ]
        })
    });
    var fullTOU = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            abbreviatedTOU,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                item: true,
                xs: 12,
                className: classes.textContainer,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    careVariant: "body3",
                    color: "textSecondary",
                    children: TERMS_OF_USE.CONTENT
                })
            })
        ]
    });
    return abbreviated ? abbreviatedTOU : fullTOU;
};
/* harmony default export */ __webpack_exports__["Z"] = (TermsOfUse);


/***/ }),

/***/ 8113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ MemberEnrollment_Welcome; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@care/navigation/dist/esm/components/LandingPageHeader/LandingPageHeader.js + 52 modules
var LandingPageHeader = __webpack_require__(1798);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(2660);
// EXTERNAL MODULE: ./src/components/shared/AppFooter.tsx
var AppFooter = __webpack_require__(576);
// EXTERNAL MODULE: ./src/components/shared/CareLogo.tsx
var CareLogo = __webpack_require__(1133);
// EXTERNAL MODULE: ./src/utilities/analyticsHelper.ts + 1 modules
var analyticsHelper = __webpack_require__(4730);
// EXTERNAL MODULE: ./src/context/FeatureFlagsContext.tsx
var FeatureFlagsContext = __webpack_require__(3854);
// EXTERNAL MODULE: ./src/components/hooks/useDirectEnrollmentData.ts + 1 modules
var useDirectEnrollmentData = __webpack_require__(6477);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(1437);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(1120);
// EXTERNAL MODULE: ./node_modules/@care/material-ui-theme/dist/esm/config/theme/theme.js + 45 modules
var theme = __webpack_require__(4932);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/esm/components/Typography/Typography.js
var Typography = __webpack_require__(7645);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 5 modules
var _sliced_to_array = __webpack_require__(603);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(414);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 5 modules
var formik_esm = __webpack_require__(6263);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 85 modules
var es = __webpack_require__(5393);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(8460);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/esm/components/Link/Link.js
var Link = __webpack_require__(9561);
// EXTERNAL MODULE: ./node_modules/@care/enterprise-components/dist/esm/components/ErrorNotification/ErrorNotification.js
var ErrorNotification = __webpack_require__(3717);
// EXTERNAL MODULE: ./node_modules/@care/enterprise-components/dist/esm/components/FormikInlineTextField/FormikInlineTextField.js
var FormikInlineTextField = __webpack_require__(7818);
;// CONCATENATED MODULE: ./src/utilities/capitalize.ts
var capitalize = function(string) {
    var ref, ref1;
    return (ref1 = (ref = string === null || string === void 0 ? void 0 : string.split(" ")) === null || ref === void 0 ? void 0 : ref.map(function(word) {
        var ref;
        return "".concat(word === null || word === void 0 ? void 0 : (ref = word[0]) === null || ref === void 0 ? void 0 : ref.toUpperCase()).concat(word === null || word === void 0 ? void 0 : word.slice(1));
    })) === null || ref1 === void 0 ? void 0 : ref1.join(" ");
};
/* harmony default export */ var utilities_capitalize = (capitalize);

// EXTERNAL MODULE: ./src/components/request/GQL.tsx
var GQL = __webpack_require__(5400);
;// CONCATENATED MODULE: ./src/components/pages/MemberEnrollment/Welcome/components/CompanySearchForm/useFindCareGroupName.tsx



var useFindCareGroupName = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(GQL/* FIND_CARE_GROUPS_BY_PARTIAL_NAME */.IB, {
        fetchPolicy: "no-cache",
        context: {
            skipAuth: true
        }
    }), 2), getSuggestions = ref[0], ref1 = ref[1], data = ref1.data, error = ref1.error;
    return {
        getSuggestions: getSuggestions,
        data: data,
        error: error
    };
};

;// CONCATENATED MODULE: ./src/components/pages/MemberEnrollment/Welcome/components/CompanySearchForm/CompanySearchInput.tsx
/* eslint-disable camelcase */ 






var _ERRORS = constants/* TEXTS.ERRORS */.oS.ERRORS, EMPLOYER_NAME_INVALID = _ERRORS.EMPLOYER_NAME_INVALID, SERVER_ERROR_GENERIC = _ERRORS.SERVER_ERROR_GENERIC;
var numResults = 10;
var minChars = 2;
var maxHeight = "170px";
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var ref, ref1, ref2;
    return {
        lookup: {
            position: "relative",
            cursor: "pointer",
            "& .suggestions": {
                position: "absolute",
                top: theme.spacing(9),
                boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.15)",
                marginLeft: theme.spacing(1),
                border: (ref = theme.palette.care) === null || ref === void 0 ? void 0 : ref.grey[200],
                borderRadius: "12px",
                zIndex: "3",
                background: (ref1 = theme.palette.care) === null || ref1 === void 0 ? void 0 : ref1.white,
                width: "94%",
                padding: 0,
                maxHeight: maxHeight,
                overflowY: "auto"
            },
            "& li": {
                listStyle: "none",
                padding: theme.spacing(1),
                textTransform: "capitalize",
                cursor: "pointer",
                "&.highlight": {
                    background: (ref2 = theme.palette.care) === null || ref2 === void 0 ? void 0 : ref2.grey[100]
                },
                "&:last-of-type": {
                    marginBottom: 0
                }
            }
        }
    };
});
var initialLoad = true;
// This is only used for reference when a selection is made that updates the userInput. If input matches what was selected, we don't want to query again.
var selectedName = "";
// Caching suggestions by userInput because fetching is slow and this is smoother than apollo caching was acting
var memoizedSuggestions = {};
var CompanySearchInput = function(param) {
    var onSelection = param.onSelection, onError = param.onError, setSSOConnectionPath = param.setSSOConnectionPath, _autoFocus = param.autoFocus, autoFocus = _autoFocus === void 0 ? false : _autoFocus, _prefillName = param.prefillName, prefillName = _prefillName === void 0 ? "" : _prefillName, _preFetch = param.preFetch, preFetch = _preFetch === void 0 ? false : _preFetch;
    var classes = useStyles();
    var suggestionsRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), showSuggestions = ref[0], setShowSuggestions = ref[1];
    var ref1 = (0,react.useState)(prefillName), userInput = ref1[0], setUserInput = ref1[1];
    var ref2 = (0,react.useState)(0), highlightedSuggestion = ref2[0], setHighlightedSuggestion = ref2[1];
    var ref3 = (0,react.useState)([]), formattedSuggestions = ref3[0], setFormattedSuggestions = ref3[1];
    var isMinChars = function() {
        return (userInput === null || userInput === void 0 ? void 0 : userInput.length) >= minChars;
    };
    var isPreFetching = initialLoad && preFetch && prefillName;
    var resetSelection = function() {
        setShowSuggestions(false);
        onSelection({
            name: "",
            shortName: "",
            ssodirectLoginEnabled: false,
            ssoConnectionPath: ""
        });
        selectedName = "";
    };
    var onGetSuggestionsCompleted = function(data) {
        var ref;
        // Filter out nulls and repeated values
        var filteredSuggestions = ((ref = data.findCareGroupsByPartialName) === null || ref === void 0 ? void 0 : ref.filter(function(param, i, arr) {
            var shortName = param.shortName;
            return shortName !== null && !arr.slice(i + 1).find(function(param) {
                var sn = param.shortName;
                return sn === shortName;
            });
        })) || [];
        var newFormattedSuggestions = filteredSuggestions.map(function(param) {
            var name = param.name, shortName = param.shortName, ssoConnectionPath = param.ssoConnectionPath, ssodirectLoginEnabled = param.ssodirectLoginEnabled;
            return {
                shortName: shortName,
                ssoConnectionPath: ssoConnectionPath,
                ssodirectLoginEnabled: ssodirectLoginEnabled,
                name: utilities_capitalize(name),
                highlighted: false
            };
        });
        setFormattedSuggestions(newFormattedSuggestions);
        setShowSuggestions(!isPreFetching);
        if (isPreFetching) {
            memoizedSuggestions[userInput.toLowerCase()] = newFormattedSuggestions;
            var autoSelection = newFormattedSuggestions.filter(function(param) {
                var name = param.name;
                return name.toLowerCase().trim() === userInput.toLowerCase().trim();
            })[0];
            if (autoSelection) handleSuggestionSelect(autoSelection);
            else {
                initialLoad = false;
                setUserInput("");
                resetSelection();
            }
        }
    };
    var ref4 = useFindCareGroupName(), getSuggestions = ref4.getSuggestions, findCareGroupData = ref4.data, serverError = ref4.error;
    var handleOnChange = function(param) {
        var value = param.currentTarget.value;
        return setUserInput(value);
    };
    var handleSuggestionSelect = function(param) {
        var name = param.name, shortName = param.shortName, ssodirectLoginEnabled = param.ssodirectLoginEnabled, ssoConnectionPath = param.ssoConnectionPath;
        setUserInput(name);
        onSelection({
            name: name,
            shortName: shortName,
            ssodirectLoginEnabled: ssodirectLoginEnabled,
            ssoConnectionPath: ssoConnectionPath
        });
        setShowSuggestions(false);
        selectedName = name;
        initialLoad = false;
        setSSOConnectionPath(ssodirectLoginEnabled ? ssoConnectionPath : "");
    };
    var handleAutoSelect = function() {
        if (!selectedName) {
            var validOption = formattedSuggestions.filter(function(param) {
                var name = param.name;
                return name.toLowerCase().trim() === userInput.toLowerCase().trim();
            })[0];
            if (validOption) handleSuggestionSelect(validOption);
        }
    };
    var handleOnBlur = function() {
        handleAutoSelect();
        if (!serverError && !selectedName && userInput) onError(EMPLOYER_NAME_INVALID);
        setShowSuggestions(false);
    };
    var handleOnFocus = function() {
        if (isMinChars() && formattedSuggestions.length) setShowSuggestions(true);
    };
    var handleHighlightAtIndex = function(index) {
        if (suggestionsRef === null || suggestionsRef === void 0 ? void 0 : suggestionsRef.current) {
            setHighlightedSuggestion(index);
            Array.from(suggestionsRef === null || suggestionsRef === void 0 ? void 0 : suggestionsRef.current.getElementsByTagName("li")).forEach(function(li, i) {
                if (index === i) {
                    li.classList.add("highlight");
                    li.scrollIntoView({
                        behavior: "smooth",
                        block: "nearest"
                    });
                } else li.classList.remove("highlight");
            });
        }
    };
    (0,react.useEffect)(function() {
        var lowerUserInput = userInput.toLowerCase();
        // Reset selection when input changes, unless the change was a result of a chosen selection (when input matches)
        if (Boolean(selectedName) && selectedName.toLowerCase() !== lowerUserInput) resetSelection();
        // Never show suggestions if min character constraint not met
        if (selectedName || !isMinChars()) setShowSuggestions(false);
        else if (memoizedSuggestions[lowerUserInput]) {
            setFormattedSuggestions(memoizedSuggestions[lowerUserInput]);
            setShowSuggestions(!isPreFetching);
            initialLoad = false;
        } else {
            getSuggestions({
                variables: {
                    partialName: userInput === null || userInput === void 0 ? void 0 : userInput.toLowerCase(),
                    numResults: numResults
                }
            });
            setShowSuggestions(!isPreFetching);
        }
    }, [
        userInput
    ]);
    (0,react.useEffect)(function() {
        if (findCareGroupData) {
            onGetSuggestionsCompleted(findCareGroupData);
        }
    }, [
        findCareGroupData
    ]);
    (0,react.useEffect)(function() {
        // Memoize suggestions the first time we get valid unique input
        if (!memoizedSuggestions[userInput.toLowerCase()]) {
            memoizedSuggestions[userInput.toLowerCase()] = formattedSuggestions;
        }
    }, [
        formattedSuggestions
    ]);
    (0,react.useEffect)(function() {
        // Highlight first suggestion when the list appears
        if (showSuggestions) handleHighlightAtIndex(0);
    }, [
        showSuggestions
    ]);
    (0,react.useEffect)(function() {
        if (serverError) onError(SERVER_ERROR_GENERIC);
    }, [
        serverError
    ]);
    var suggestionList = function() {
        return showSuggestions && Boolean(formattedSuggestions === null || formattedSuggestions === void 0 ? void 0 : formattedSuggestions.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: "suggestions",
            "data-testid": "suggestions",
            ref: suggestionsRef,
            children: formattedSuggestions === null || formattedSuggestions === void 0 ? void 0 : formattedSuggestions.map(function(suggestion, i) {
                return /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable jsx-a11y/mouse-events-have-key-events */ /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: i === 0 ? "highlight" : "",
                    onMouseDown: function(e) {
                        return e.preventDefault();
                    },
                    onClick: function() {
                        return handleSuggestionSelect(suggestion);
                    },
                    onMouseOver: function() {
                        return handleHighlightAtIndex(i);
                    },
                    children: suggestion.name
                }, suggestion.name);
            })
        });
    };
    var handleKeyboardInput = function(e) {
        var length = formattedSuggestions === null || formattedSuggestions === void 0 ? void 0 : formattedSuggestions.length;
        var nextIndex = highlightedSuggestion;
        if (showSuggestions && length) {
            switch(e.nativeEvent.key){
                case "ArrowDown":
                    e.preventDefault(); // prevent moving the cursor inside the input while selecting options
                    nextIndex = (highlightedSuggestion + 1) % length;
                    handleHighlightAtIndex(nextIndex);
                    break;
                case "ArrowUp":
                    e.preventDefault(); // prevent moving the cursor inside the input while selecting options
                    nextIndex = (highlightedSuggestion ? highlightedSuggestion - 1 : length - 1) % length;
                    handleHighlightAtIndex(nextIndex);
                    break;
                case "Enter":
                    handleSuggestionSelect(formattedSuggestions[highlightedSuggestion]);
                    setShowSuggestions(false);
                    break;
                case "Escape":
                    setShowSuggestions(false);
                    break;
                default:
                    return;
            }
            setHighlightedSuggestion(nextIndex);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.lookup,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikInlineTextField/* default */.Z, {
                autoFocus: autoFocus,
                id: "groupShortName",
                name: "groupShortName",
                label: "Employer name",
                autoComplete: "off",
                value: userInput,
                onKeyDown: handleKeyboardInput,
                onFocus: handleOnFocus,
                onBlur: handleOnBlur,
                onChange: handleOnChange
            }),
            suggestionList()
        ]
    });
};
/* harmony default export */ var CompanySearchForm_CompanySearchInput = (CompanySearchInput);

// EXTERNAL MODULE: ./src/components/shared/TermsOfUse.tsx
var TermsOfUse = __webpack_require__(9051);
// EXTERNAL MODULE: ./src/components/shared/OverlaySpinner.tsx + 3 modules
var OverlaySpinner = __webpack_require__(2155);
// EXTERNAL MODULE: ./src/components/hooks/useEnterKey.ts
var useEnterKey = __webpack_require__(566);
;// CONCATENATED MODULE: ./src/components/pages/MemberEnrollment/Welcome/components/CompanySearchForm/index.tsx





















var INPUT_WIDTH = "296px";
var CTA_TEXT = "Join now";
var validationSchema = es/* object */.Ry({
    email: es/* string */.Z_().email("Enter a valid email").required("Email is required"),
    groupShortName: es/* string */.Z_().required("Employer name is required"),
    groupDisplayName: es/* string */.Z_().required("Employer name is required")
});
var CompanySearchForm = function(param) {
    var logger = param.logger;
    var ref, ref1;
    var isMobile = (0,useMediaQuery/* default */.Z)(theme/* default.breakpoints.down */.Z.breakpoints.down("xs"));
    var router = (0,next_router.useRouter)();
    var ref2 = (0,useDirectEnrollmentData/* default */.ZP)(), fetch = ref2.fetch, update = ref2.update;
    var storageValue = fetch();
    var excludeClients = (0,FeatureFlagsContext/* useFlag */.P5)(constants/* FEATURE_FLAGS.ENT_REDIRECT_LD_FLAG.key */.y8.ENT_REDIRECT_LD_FLAG.key);
    var lifeCareTransitionD2EClients = (0,FeatureFlagsContext/* useFlag */.P5)(constants/* FEATURE_FLAGS.ENT_LIFECARE_TRANSITION_D2E_CLIENT_FLAG.key */.y8.ENT_LIFECARE_TRANSITION_D2E_CLIENT_FLAG.key);
    var ref3 = (0,react.useState)(false), memberExists = ref3[0], setMemberExists = ref3[1];
    var ref4 = (0,react.useState)(""), apolloError = ref4[0], setApolloError = ref4[1];
    var ref5 = (0,react.useState)(false), isSubmitting = ref5[0], setIsSubmitting = ref5[1];
    var ref6 = (0,react.useState)(""), ssoConnectionPath = ref6[0], setSSOConnectionPath = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(GQL/* VERIFY_EMPLOYEE_EXISTS_BY_EMAIL */.tc, {
        context: {
            skipAuth: true
        }
    }), 2), verifyEmployeeExists = ref7[0], ref8 = ref7[1], verifyEmployeeData = ref8.data, verifyEmployeeError = ref8.error, loading = ref8.loading;
    (0,react.useEffect)(function() {
        if (verifyEmployeeData) {
            var enterpriseVerifyEmployeeExistsByEmail = verifyEmployeeData.enterpriseVerifyEmployeeExistsByEmail;
            if (enterpriseVerifyEmployeeExistsByEmail.__typename === "EnterpriseVerifyEmployeeExistsByEmailSuccess") {
                var alreadyExists = enterpriseVerifyEmployeeExistsByEmail.memberExists;
                if (!alreadyExists) {
                    if (ssoConnectionPath) {
                        window.location.href = ssoConnectionPath;
                        return;
                    }
                    if (Boolean(lifeCareTransitionD2EClients) && storageValue.groupShortName in lifeCareTransitionD2EClients) {
                        router.push("".concat(constants/* memberEnrollment */.y).concat(constants/* ENTERPRISE_ROUTES.LIFECARE_AUTHENTICATION */.O$.LIFECARE_AUTHENTICATION, "?groupShortName=").concat(storageValue.groupShortName));
                        return;
                    }
                    router.push("".concat(constants/* memberEnrollment */.y).concat(constants/* ENTERPRISE_ROUTES.PERSONAL_INFO */.O$.PERSONAL_INFO));
                    return;
                }
                if (alreadyExists) {
                    logger({
                        name: constants/* EventNames.ERROR_VIEWED */.Vy.ERROR_VIEWED,
                        data: {
                            message: constants/* TEXTS.ERRORS.EMAIL_ALREADY_EXISTS */.oS.ERRORS.EMAIL_ALREADY_EXISTS,
                            step_name: "Welcome",
                            step_number: "0",
                            wps_group: formik.values.groupShortName
                        }
                    });
                }
                setMemberExists(enterpriseVerifyEmployeeExistsByEmail.memberExists);
            }
            if (enterpriseVerifyEmployeeExistsByEmail.__typename === "EnterpriseFailureResponse") {
                setApolloError(enterpriseVerifyEmployeeExistsByEmail.knownErrors[0].message);
            }
            setIsSubmitting(false);
        }
        if (verifyEmployeeError) {
            setIsSubmitting(false);
            setApolloError(constants/* TEXTS.ERRORS.UNEXPECTED_ERROR */.oS.ERRORS.UNEXPECTED_ERROR);
        }
    }, [
        verifyEmployeeData,
        verifyEmployeeError
    ]);
    var handleFormSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            var groupShortName, groupDisplayName, email;
            return (0,tslib_es6.__generator)(this, function(_state) {
                setIsSubmitting(true);
                groupShortName = values.groupShortName, groupDisplayName = values.groupDisplayName, email = values.email;
                update({
                    groupShortName: groupShortName,
                    groupDisplayName: groupDisplayName,
                    email: email
                });
                if (Boolean(excludeClients) && groupShortName in excludeClients) {
                    window.location.href = "".concat(window.location.protocol, "//").concat(window.location.host, "/").concat(groupShortName);
                    return [
                        2
                    ];
                }
                if (email && groupShortName) {
                    verifyEmployeeExists({
                        variables: {
                            input: {
                                email: email,
                                groupShortName: groupShortName
                            }
                        }
                    });
                }
                return [
                    2
                ];
            });
        });
        return function handleFormSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            groupShortName: storageValue.groupShortName,
            groupDisplayName: storageValue.groupDisplayName,
            email: storageValue.email
        },
        validationSchema: validationSchema,
        validateOnBlur: true,
        onSubmit: handleFormSubmit
    });
    var handleSelection = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var name, shortName;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        name = param.name, shortName = param.shortName;
                        formik.setFieldValue("groupShortName", shortName);
                        formik.setFieldValue("groupDisplayName", name);
                        if (!(name.length >= 2)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            formik.setFieldTouched("groupShortName", true, true)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            formik.setFieldTouched("groupDisplayName", true, true)
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSelection(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmit = function() {
        logger({
            name: constants/* EventNames.CTA_INTERACTED */.Vy.CTA_INTERACTED,
            data: {
                cta_text: CTA_TEXT,
                user_email: formik.values.email,
                wps_group: formik.values.groupShortName,
                lifecare_transition_client: isLifecareTransitionClient().toString(),
                sso_client: Boolean(ssoConnectionPath).toString()
            }
        });
        formik.submitForm();
    };
    var isLifecareTransitionClient = function() {
        return formik.values.groupShortName ? formik.values.groupShortName in lifeCareTransitionD2EClients : false;
    };
    var classes = (0,makeStyles/* default */.Z)(function() {
        return {
            grid: {
                display: "grid",
                gridTemplateAreas: "\n        'form'\n        'cta'\n      "
            },
            form: {
                gridArea: "form",
                display: "grid",
                position: "relative",
                minWidth: "calc(".concat(INPUT_WIDTH, " * 2 + 16px)"),
                "& .fields": {
                    display: "grid",
                    gap: isMobile ? 0 : "16px",
                    gridTemplateColumns: isMobile ? "1fr" : "repeat(2, ".concat(INPUT_WIDTH, ")"),
                    gridAutoRows: isMobile ? "1fr" : "100%",
                    padding: "0 0 16px",
                    paddingRight: "24px",
                    "& .MuiTextField-root": {
                        padding: 0,
                        width: "clamp(".concat(INPUT_WIDTH, ", 400px, 100%)")
                    }
                }
            },
            button: {
                gridArea: "cta",
                display: "block",
                position: isMobile ? "sticky" : "relative",
                bottom: isMobile ? "20px" : 0,
                margin: isMobile ? "24px auto 0" : "24px 0 0",
                minHeight: "56px",
                marginBottom: theme/* default.spacing */.Z.spacing(4),
                zIndex: 2
            }
        };
    })();
    var handleLogin = function() {
        logger({
            name: constants/* EventNames.LOGIN */.Vy.LOGIN,
            data: {
                login_location: constants/* LoginLocation.WELCOME_PAGE_EMAIL_ERROR */.gc.WELCOME_PAGE_EMAIL_ERROR
            }
        });
        window.location.href = "/vis/auth/login";
    };
    var handleCompanySearchError = function(errorMessage) {
        formik.setFieldError("groupShortName", errorMessage);
        formik.setFieldTouched("groupShortName", true, false);
    };
    var helpText = memberExists && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
        color: "error",
        careVariant: "info1",
        children: [
            constants/* TEXTS.ERRORS.EMAIL_ALREADY_EXISTS */.oS.ERRORS.EMAIL_ALREADY_EXISTS,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                onClick: handleLogin,
                careVariant: "link4",
                bold: true,
                children: " Log in?"
            })
        ]
    });
    var companySearchPreFillName = (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.groupName) || (storageValue === null || storageValue === void 0 ? void 0 : storageValue.groupDisplayName) || "";
    var shouldAutoFocusEmail = Boolean(companySearchPreFillName) && !storageValue.email;
    (0,useEnterKey/* default */.Z)(true, handleSubmit);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlaySpinner/* default */.Z, {
                isTransparent: true,
                isOpen: isSubmitting
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.grid,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.form,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* FormikProvider */.Hy, {
                            value: formik,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorNotification/* default */.Z, {
                                    text: apolloError
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "fields",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanySearchForm_CompanySearchInput, {
                                            onSelection: handleSelection,
                                            onError: handleCompanySearchError,
                                            setSSOConnectionPath: setSSOConnectionPath,
                                            autoFocus: !shouldAutoFocusEmail,
                                            prefillName: companySearchPreFillName,
                                            preFetch: Boolean(router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.groupName)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikInlineTextField/* default */.Z, {
                                            autoFocus: shouldAutoFocusEmail,
                                            id: "email",
                                            name: "email",
                                            label: "Email",
                                            helperText: helpText
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        size: "large",
                        variant: "contained",
                        color: "primary",
                        onClick: handleSubmit,
                        disabled: loading,
                        className: classes.button,
                        children: CTA_TEXT
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsOfUse/* default */.Z, {
                        amplitudeLogger: logger,
                        buttonCaption: CTA_TEXT,
                        abbreviated: true,
                        flat: true
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CompanySearchForm = (CompanySearchForm);

;// CONCATENATED MODULE: ./src/components/pages/MemberEnrollment/Welcome/images.ts

var oldCmsPrefix = "https://www.care.com//img/cms/web/careAtWork/directEnrollment";
var WELCOME_IMAGES = {
    FLORAL_LEFT: "".concat(constants/* CMS_PREFIX */.XM, "/Floral_Left_DT@4x-min.png"),
    FLORAL_RIGHT: "".concat(constants/* CMS_PREFIX */.XM, "/Floral_Right_DT@4x-min.png"),
    FLORAL_MW: "".concat(constants/* CMS_PREFIX */.XM, "/Floral_MW@4x-min.png"),
    MOM_AND_CHILD_DT: "".concat(constants/* CMS_PREFIX */.XM, "/photo@2x-min.png"),
    MOM_AND_CHILD_MW: "".concat(oldCmsPrefix, "/MomandchildMW.png"),
    FLORAL_CLUSTER_1: "".concat(oldCmsPrefix, "/floral_01.png"),
    FLORAL_CLUSTER_2: "".concat(oldCmsPrefix, "/Floral_cluster_02_portrait_4.png")
};

;// CONCATENATED MODULE: ./src/components/pages/MemberEnrollment/Welcome/components/Hero/index.tsx










var Hero = function() {
    var isMobile = (0,useMediaQuery/* default */.Z)(theme/* default.breakpoints.down */.Z.breakpoints.down("xs"));
    var isLargeScreen = (0,useMediaQuery/* default */.Z)(theme/* default.breakpoints.up */.Z.breakpoints.up("lg"));
    var xxs = "@media (max-height: 900px) and (max-width: 600px)"; // for hiding hero image on very small screens
    var logger = (0,analyticsHelper/* useEventLogger */.ld)({
        user_flow: "Direct to Enrollment"
    });
    var floralClusterImg = {
        src: isMobile ? WELCOME_IMAGES.FLORAL_MW : WELCOME_IMAGES.FLORAL_LEFT,
        alt: "cluster of flowers",
        className: isMobile ? "flowerMW" : "flowerLeft"
    };
    var floralImg = {
        src: WELCOME_IMAGES.FLORAL_RIGHT,
        alt: "flower",
        className: "flowerRight"
    };
    var momAndChildImg = {
        src: isMobile ? WELCOME_IMAGES.MOM_AND_CHILD_MW : WELCOME_IMAGES.MOM_AND_CHILD_DT,
        alt: "mother reading with child"
    };
    var headerText = "Join to find care when and where you need it";
    var subHeaderText = "Get access to your free, employer-sponsored account today";
    var heroLayout = isMobile ? "'image'\n       'formWrapper'\n  " : "'formWrapper image'";
    var formWrapperLayout = "\n    'header'\n    'subHeader'\n    'form'";
    var classes = (0,makeStyles/* default */.Z)(function() {
        var _obj;
        return {
            hero: {
                position: "relative",
                display: "grid",
                gridTemplateAreas: heroLayout,
                gridAutoColumns: isMobile ? "100%" : "1fr auto",
                justifyContent: "space-between",
                paddingLeft: isMobile ? "24px" : "152px",
                backgroundColor: theme/* default.palette.care.grey.50 */.Z.palette.care.grey[50],
                overflow: isMobile ? "initial" : "hidden",
                zIndex: 0,
                "& .formWrapper": {
                    display: "grid",
                    gridTemplateAreas: formWrapperLayout,
                    gridTemplateRows: "auto auto 1fr",
                    justifyContent: isLargeScreen ? "center" : "initial",
                    "& .header": (0,_define_property/* default */.Z)({
                        gridArea: "header",
                        marginTop: isMobile ? 0 : "100px",
                        marginBottom: "16px"
                    }, xxs, {
                        marginTop: "80px"
                    }),
                    "& .subHeader": {
                        gridArea: "subHeader",
                        alignSelf: "center"
                    },
                    "& .form": {
                        gridArea: "form",
                        marginBottom: isMobile ? "32px" : "90px"
                    }
                },
                "& .heroImageWrapper": (_obj = {
                    gridArea: "image",
                    position: "relative",
                    minHeight: isMobile ? 0 : "548px",
                    height: isMobile ? "450px" : "initial",
                    maxHeight: isMobile ? "initial" : "650px",
                    width: isMobile ? "574px" : "640px",
                    margin: 0,
                    pointerEvents: "none"
                }, (0,_define_property/* default */.Z)(_obj, xxs, {
                    height: 0
                }), (0,_define_property/* default */.Z)(_obj, theme/* default.breakpoints.up */.Z.breakpoints.up("lg"), {
                    width: "40vw"
                }), _obj),
                "& .flowerRight": {
                    position: "absolute",
                    left: isLargeScreen ? "unset" : "10%",
                    right: isLargeScreen ? "calc(40vw - 180px)" : "unset",
                    height: "82px",
                    width: "140px"
                },
                "& .flowerLeft": {
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    height: "200px",
                    width: "139px"
                },
                "& .flowerMW": {
                    position: "absolute",
                    top: 0,
                    right: 0,
                    height: "139px",
                    width: "189px"
                },
                "& img": {
                    zIndex: -1
                }
            }
        };
    })();
    // This is a temporary optimization. By appending the `?im=` parameter, we are getting an optimized image from Akamai.
    // Images optimized in this way are cached on edge servers only after first fetch from each server and stay cached for at least 30 days.
    // TODO - replace with standard loader once we establish one.
    var imageLoader = function(param) {
        var src = param.src;
        return "".concat(src, "?im=");
    };
    var floralClusterImage = /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        priority: true,
        src: floralClusterImg.src,
        alt: floralClusterImg.alt,
        layout: "fill",
        objectFit: "contain",
        loader: imageLoader,
        sizes: "50vw"
    });
    var heroImage = /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        className: "heroImage",
        priority: true,
        src: momAndChildImg.src,
        alt: momAndChildImg.alt,
        layout: "fill",
        objectFit: "cover",
        objectPosition: isMobile ? "top" : "center",
        loader: imageLoader,
        sizes: "50vw"
    });
    var flowerRightImage = !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: floralImg.className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            priority: true,
            src: floralImg.src,
            alt: floralImg.alt,
            layout: "fill",
            objectFit: "contain",
            loader: imageLoader,
            sizes: "50vw"
        })
    });
    var renderForm = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "formWrapper",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    careVariant: "display3",
                    className: "header",
                    children: headerText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body1",
                    className: "subHeader",
                    children: subHeaderText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "form",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompanySearchForm, {
                        logger: logger
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: classes.hero,
        children: [
            renderForm(),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                className: "heroImageWrapper",
                children: [
                    heroImage,
                    flowerRightImage
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: floralClusterImg.className,
                children: floralClusterImage
            })
        ]
    });
};
/* harmony default export */ var components_Hero = (Hero);

;// CONCATENATED MODULE: ./src/components/pages/MemberEnrollment/Welcome/components/PageContent.tsx





var PageContent = function() {
    var logger = (0,analyticsHelper/* useEventLogger */.ld)({
        user_flow: "Direct to Enrollment"
    });
    (0,react.useEffect)(function() {
        logger({
            name: constants/* EventNames.SCREEN_VIEWED */.Vy.SCREEN_VIEWED,
            data: {
                step_name: "Welcome",
                step_number: "0"
            }
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Hero, {});
};
/* harmony default export */ var components_PageContent = (PageContent);

;// CONCATENATED MODULE: ./src/components/pages/MemberEnrollment/Welcome/index.tsx











var Welcome = function() {
    var logger = (0,analyticsHelper/* useEventLogger */.ld)({
        user_flow: "Direct to Enrollment"
    });
    var utmRedirectLdFlagResult = (0,FeatureFlagsContext/* useFlag */.P5)(constants/* FEATURE_FLAGS.ENT_UTM_REDIRECT_FLAG.key */.y8.ENT_UTM_REDIRECT_FLAG.key);
    var update = (0,useDirectEnrollmentData/* default */.ZP)().update;
    var handleLogin = function() {
        logger({
            name: constants/* EventNames.LOGIN */.Vy.LOGIN,
            data: {
                login_location: constants/* LoginLocation.HEADER */.gc.HEADER
            }
        });
        window.location.href = "/vis/auth/login";
    };
    (0,react.useEffect)(function() {
        update({
            utmRedirectFlagEnabled: utmRedirectLdFlagResult
        });
    }, []);
    var headerButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        color: "secondary",
        variant: "outlined",
        onClick: handleLogin,
        children: "Login"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPageHeader/* default */.Z, {
                button: headerButton,
                logo: /*#__PURE__*/ (0,jsx_runtime.jsx)(CareLogo/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PageContent, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppFooter/* default */.Z, {
                whiteBackground: true
            })
        ]
    });
};
/* harmony default export */ var MemberEnrollment_Welcome = (Welcome);

;// CONCATENATED MODULE: ./src/pages/member-enrollment/welcome.tsx



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [95,652,774,888,179], function() { return __webpack_exec__(6562); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);